import { spawn } from 'redux-saga/effects';

import { sagas as pingSagas } from './pingModule';
import { sagas as whatismyipSagas } from './whatismyipModule';

export default function* sagas() {
	yield spawn(pingSagas);
	yield spawn(whatismyipSagas);
}
